package demos.buttons

import androidx.compose.animation.animateColorAsState
import androidx.compose.animation.core.Spring
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.spring
import androidx.compose.animation.core.tween
import androidx.compose.foundation.background
import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material.LocalContentColor
import androidx.compose.material.LocalTextStyle
import androidx.compose.material.Text
import androidx.compose.runtime.*
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.scale
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp


const val GRADIENT_BUTTON = "a01f922cfa5acaa36cc848530ce71dd20720c0118ab36fe8298c9b1004f556dd"

@Composable
fun GradientButton() {
    var touched by remember { mutableStateOf(false) }
    val s = remember { Color(0xFFF0AE08) }
    val e = remember { Color(0xFFB738EE) }

    val startColor by animateColorAsState(
        targetValue = if (touched) s else e,
        animationSpec = tween(500)
    )

    val endColor by animateColorAsState(
        targetValue = if (touched) e else s,
        animationSpec = tween(500)
    )

    val scale by animateFloatAsState(
        targetValue = if (touched) .9f else 1f, animationSpec = spring(
            dampingRatio = Spring.DampingRatioMediumBouncy,
            stiffness = Spring.StiffnessMediumLow
        )
    )

    Box(
        modifier = Modifier
            .padding(4.dp)
            .pointerInput(Unit) {
                detectTapGestures(
                    onPress = {
                        touched = true
                        awaitRelease()
                        touched = false
                    }
                )
            }
            .scale(scale)
            .background(
                brush = Brush.linearGradient(
                    listOf(
                        startColor,
                        endColor
                    ),
                    Offset(0.0f, 0.0f), Offset(Float.POSITIVE_INFINITY, Float.POSITIVE_INFINITY)
                ),
                CircleShape
            )
            .padding(horizontal = 24.dp, vertical = 8.dp)
    ) {
        CompositionLocalProvider(
            LocalContentColor provides Color.Black,
//            LocalTextStyle provides TextStyle(
//                fontWeight = FontWeight.Medium,
//                fontSize = 36.sp
//            ),
        ) {
            Text(text = "Gradient Button")
        }
    }
}